module.exports = __webpack_public_path__ + "img/stethoscope.e23db1e7.svg";